/**
 * Brazilian Portuguese (pt-BR) mappings for NHL Dashboard
 * Translations for both desktop and mobile NHL components
 */

export const nhlDashPtBR = {
  // Header & Navigation
  "Sports Hub • NHL": "Centro Esportivo • NHL",
  "NHL Terminal": "Terminal NHL",
  "Track live NHL games, monitor league action, and tap into AI predictions for every matchup.": "Acompanhe jogos ao vivo da NHL, monitore a ação da liga e acesse previsões da IA para cada confronto.",
};